import type { DhImage__Input, UnionImage } from '~/graphql/types';
import { assertNeverWithoutThrowing } from '../assertion';
import { reporter } from '~/hooks/useErrorReporter';
import cleanedFilename from '../cleanedFilename';

/**
 *
 * @param {UnionImage} image - The image to get the input for
 * keywords: imageinput, convert image to input
 */
const getImageInput = (
  image: UnionImage | null | undefined,
): DhImage__Input | undefined => {
  if (!image) return undefined;

  switch (image.__typename) {
    case 'AssetImage':
      if (!image.assetId) {
        reporter.captureException(
          new Error(
            `AssetImage has no assetId in ${cleanedFilename(__filename)}`,
          ),
        );
        return undefined;
      }
      return { Asset: { assetId: image.assetId } };
    case 'DHImage':
      if (!image.s3key) {
        reporter.captureException(
          new Error(`DHImage has no s3key in ${cleanedFilename(__filename)}`),
        );
        return undefined;
      }
      return { Image: { s3key: image.s3key } };
    default:
      assertNeverWithoutThrowing(image);
      return undefined;
  }
};

export default getImageInput;
